import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-master-data-list',
  templateUrl: './master-data-list.component.html',
  styleUrls: ['./master-data-list.component.css']
})
export class MasterDataListComponent implements OnInit {

  menuList: any;
  allowedComponents = new Set<string>();

  constructor(private router:Router) { }

  ngOnInit(): void {
    this.menuList = JSON.parse(localStorage.getItem('menuList'));
    this.menuList.forEach(menu => {
    menu.menu?.menuComponents?.forEach(component => {
      this.allowedComponents.add(component.name);
    });
  });
  }

  hasAccess(componentName: string): boolean {
  return this.allowedComponents.has(componentName);
}

  assignmentClick(){
    this.router.navigate(['dashboard/manage-assignment']);
  }
  taskClick(){
    this.router.navigate(['dashboard/manage-task']);
  }
  branchClick(){
    this.router.navigate(['dashboard/manage-branch']);
  }
  financialYearClick(){
    this.router.navigate(['dashboard/manage-financial-year']);
  }
  rolesClick(){
    this.router.navigate(['dashboard/manage-role']);
  }
  designationClick(){
    this.router.navigate(['dashboard/manage-designation']);
  }
  conveyanceRatesClick(){
    this.router.navigate(['dashboard/conveyance-rates']);
  }
  standardRatesClick(){
    this.router.navigate(['dashboard/standard-rates']);
  }
  branchwiseHolidayClick(){
    this.router.navigate(['dashboard/branch-holidays']);
  }
  companyConfigurationClick(){
    this.router.navigate(['dashboard/comapny-configuration']);
  }
  articleStipendMasterClick(){
    this.router.navigate(['dashboard/article-stipend']);
  }
  manageAnnouncementClick(){
    this.router.navigate(['dashboard/manage-announcement']);
  }
  serviceVerticalClick(){
    this.router.navigate(['dashboard/service-vertical']);
  }
}
